module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/past-projects/open_doors_singapore@2x-26fb751163c87ac4c7871f56f1eddba1.jpeg";